import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@iconify/icons-mdi/delete";
import { InlineIcon } from "@iconify/react";

interface MassUploadDeleteButtonProps {
  setShowConfirmDialog: (value: boolean) => void;
  id?: string;
}

export const MassUploadDeleteButton: React.FC<MassUploadDeleteButtonProps> = ({
  setShowConfirmDialog,
  id = "deleteIcon",
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center">
      <InlineIcon
        id={id}
        icon={DeleteIcon}
        width="24px"
        style={{
          color: theme.palette.owGray.main,
          cursor: "pointer",
        }}
        onClick={() => setShowConfirmDialog(true)}
      />
    </Box>
  );
};

export default MassUploadDeleteButton;
